// extracted by mini-css-extract-plugin
export default {"container":"speaker_container__YAJ8N","spekars":"speaker_spekars__7053X","one":"speaker_one__UM9bU","two":"speaker_two__awjWY","hidden":"speaker_hidden__SRUq8"};